export enum FIELD_NAMES {
    DOB = "dob",
    EMPLOYMENT_TYPE = "employmentType",
    SALARY_MODE = "salaryMode",
    NET_MONTHLY_INCOME = "netMonthlyIncome",
    CURRENT_EMPLOYER = "currentEmployer",
    WORK_CIN = "workCin",
    MOBILE = "mobile",
    ADDRESS_PINCODE = "addressPincode",
    WORK_EXPERIENCE_MONTHS = "workExperienceMonths",
    HOUSE = "house",
    STREET = "street",
    LOCALITY = "locality",
    LANDMARK = "landmark",
    PINCODE = "pincode",
    EMPLOYER_TYPE = "employerType",
    RES_TENURE = "resTenure",
    REFERENCE_NAME = "referenceName",
    REFERENCE_MOBILE = "referenceMobile",
    RESIDENT_TYPE = "residentType",
    AADHAAR = "aadhar",
    CAPTCHA = "captcha",
    AMOUNT = "amount",
    PURPOSE = "purpose",
    TENURE = "tenure",
    ACCOUNT_NUMBER = "accountNumber",
    IFSC = "ifsc",
    BENEFICIARY_NAME = "beneficiaryName",
    EMPLOYEE_ID = "employeeId",
    TOTAL_DEPENDENTS = "numDependents",
    REFERENCES = "references",
    DURATION = "duration",
    DESIGNATION = "designation",
    PAN = "panNumber",
}

export enum ApplicationStatus {
    INITIATED = "INITIATED",
    INCOMPLETE_INFO = "INCOMPLETE_INFO",
    APPROVED = "APPROVED",
    CUST_CONSENT_PENDING = "CUST_CONSENT_PENDING",
    CUST_CONSENT_GIVEN = "CUST_CONSENT_GIVEN",
    AGENT_ASSIGNED = "AGENT_ASSIGNED",
    DOC_RECEIVED_BY_AGENT = "DOC_RECEIVED_BY_AGENT",
    DOC_PROCESSING = "DOC_PROCESSING",
    VERIFYING_DOCS = "VERIFYING_DOCS",
    RE_DOC_REQUESTED = "RE_DOC_REQUESTED",
    DISBURSAL_PENDING = "DISBURSAL_PENDING",
}

export enum ApplicationSubStatus {
    BS_6M_MISSING = "BS_6M_MISSING",
    BS_SALARY_MISSING = "BS_SALARY_MISSING",
    BS_NET_BANKING = "BS_NET_BANKING",
}
